import { render, staticRenderFns } from "./DepartmentPermissionsTab.vue?vue&type=template&id=76669cd4&scoped=true"
import script from "./DepartmentPermissionsTab.vue?vue&type=script&lang=js"
export * from "./DepartmentPermissionsTab.vue?vue&type=script&lang=js"
import style0 from "./DepartmentPermissionsTab.vue?vue&type=style&index=0&id=76669cd4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76669cd4",
  null
  
)

export default component.exports